function normalizeAshleyConversationTranscript(transcript) {
  return String(transcript || "")
    .toLowerCase()
    .replace(/['’]/g, "")
    .replace(/[^\w\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

const CONVERSATION_CANCEL_PHRASES = Object.freeze([
  "cancel",
  "stop listening",
  "never mind",
  "nevermind",
  "that's all",
  "thats all",
  "exit",
]);

export function isAshleyConversationCancelPhrase(transcript) {
  const normalized = normalizeAshleyConversationTranscript(transcript);
  if (!normalized) {
    return false;
  }

  return CONVERSATION_CANCEL_PHRASES.some(
    (phrase) =>
      normalized === phrase || normalized.startsWith(`${phrase} `),
  );
}
